(function () {
    var onDomComplete = function (fn) { document.addEventListener("readystatechange", function (e) { if (document.readyState === "complete") { fn(e); } }); };
    var getDetailItem = function () {
        if (typeof homeDetail !== "undefined") {
            return homeDetail;
        } else if (typeof commDetail !== "undefined") {
            return commDetail;
        }
        return null; // Basic :p
    };
    onDomComplete(function () {
        var observer = null;
        var onIntersection = function (entries, observer) {
            entries.forEach(function (entry) {
                if (!(entry.intersectionRatio > 0)) return;

                var detailItem = getDetailItem();
                if (detailItem === null || detailItem.parameters.showMortgage) {
                    var detailPriceElm = document.querySelector(".nhs_DetailsPrice");
                    var price1 = detailPriceElm ? detailPriceElm.textContent : "";
                    var price2 = price1.split("-")[0];
                    var price3 = parseFloat(price2.replace(/[^0-9-.]/g, ''));
                    var postalCodeElm = document.querySelector("#nhs_FormAddress > span:nth-child(4)");
                    var postalCode = postalCodeElm ? postalCodeElm.textContent : "";
                    var detailCardTemplate = `<section class="nhs-c-wrapper__section">
                                                <div class="nhs-c-wrapper__section-container nhs-mq-wrapper__section-container--medium nhs-u-gap--500">
                                                  <h3 class="nhs-c-heading--black-1000-subhead-3-large-light">Mortgage rates & offers</h3>
                                                  <iframe aria-label="Mortgage rates & offers" class="nhs-c-wrapper__mortgage-iframe" src='https://widgets.icanbuy.com/c/standard/us/en/mortgage/tables/Mortgage.aspx?siteid=206f35c4e7ee1a32&amp;searchbtnbgcolor=ffce34&amp;searchbtntextcolor=2c2c2c&amp;listingbtnbgcolor=0079d2&amp;loan_type=PURCH&amp;zip=${postalCode}&amp;property_value=${price3}' width='665' height='710'></iframe>
                                                </div>
                                              </section>`;
                    var detailCard = document.createRange().createContextualFragment(detailCardTemplate).querySelector("*");

                    if (entry.target && entry.target.id === "nhs_reviewsInfo") {
                        var mortgageContainer = document.getElementById("nhs_MortgageContainer");

                        if (mortgageContainer) {
                            detailCard.classList.remove("nhs_DetailCard");
                            mortgageContainer.appendChild(detailCard);
                        }
                    } else if (/\/community(detail)?\//.test(location.pathname)) { // Community Detail
                        var nearbyHomesContent = document.querySelector(".nhs_DetailMain > #nhs_NearbyHomesContent");
                        if (nearbyHomesContent) {
                            nearbyHomesContent.parentElement.insertBefore(detailCard, nearbyHomesContent);
                        }
                    } else if (/\/basiccommunity\//.test(location.pathname)) { // Basic Community Detail
                        var mortgageContainer = document.getElementById("nhs_MortgageContainer");
                        if (mortgageContainer) {
                            detailCard.classList.remove("nhs_DetailCard")
                            mortgageContainer.appendChild(detailCard);
                      }
                    } else if (/\/plandetail|specdetail|homedetail|sold\//.test(location.pathname)) { // Home Detail
                        var homeCarousel = document.getElementById("nhs_HomeCarousel");
                        if (homeCarousel) {
                            homeCarousel.parentElement.insertBefore(detailCard, homeCarousel);
                        }
                    } else if (/\/basicdetail\//.test(location.pathname)) {
                        var refElm = document.querySelector("#nhs_DetailsMain > :last-child"); // Basic Home Detail
                        if (refElm) {
                            refElm.parentElement.insertBefore(detailCard, refElm);
                        }
                    }
                }

                observer.disconnect();
            });
        };
        observer = new IntersectionObserver(onIntersection);
        if (document.querySelector("#nhs_DetailsMain,#map-directions-container,#nhs_reviewsInfo") == null) {
            var observeElement = document.querySelector("#nhs_DetailsMain,#nhs_nearbyHomesSection,#next-steps-container,#SchoolsAndAmenities");
            if (observeElement) {
                observer.observe(observeElement);
            }
        } else {
            observer.observe(document.querySelector("#nhs_DetailsMain,#map-directions-container,#nhs_reviewsInfo"));
        }
    });
})();